import util from '../util'

let controller = 'Volumetria'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put', 'persist']), {
  GetAll (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  }
})
